export default __webpack_public_path__ + "static/media/DirectOrder.0fe94427.jpg";